import React, {PureComponent} from 'react';
import {TextArea} from 'semantic-ui-react';
import {FemaGoModal} from 'app-ui-componentlibrary';

export default class CommentModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      openModal: true,
      rankComments: this.props.comments,
    };
  }

  handleCommentsChange = (event) => {
    event.preventDefault();
    const {name, value} = event.target;
    this.setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  closeModal = () => {
    this.setState({
      openModal: false,
      rankComments: this.props.comments,
    });
    this.props.resetActions();
  };

  handleSave = () => {
    this.props.handleSave(this.props.entityId, this.state.rankComments);
    this.setState({
      openModal: false,
    });
  };

  render() {
    const {readOnly} = this.props;
    return (
      <FemaGoModal
        size="tiny"
        title="Comments (optional)"
        open={this.state.openModal}
        buttonText={'Save'}
        confirmAction={this.handleSave}
        cancelAction={this.closeModal}
        readOnly={readOnly}
      >
        <div>
          {!readOnly ? (
            <TextArea
              style={{width: '100%', height: '100px'}}
              value={this.state.rankComments}
              maxLength={4000}
              name="rankComments"
              onChange={(event) => this.handleCommentsChange(event)}
            />
          ) : (
            <p>{this.state.rankComments}</p>
          )}
        </div>
      </FemaGoModal>
    );
  }
}
